<div>
  <loadable class="rv-grid large rv-grow" [data]="_.accountMonitoringLoadable">
    <super-table
      class="scrollable rv-shrink"
      [data]="_.entries?.data"
      [view]="_.table.tableView | async"
      (viewChange)="_.table.tableView.next($event)"
    >
      <tr class="rv-header-row" superTableHeaderRow>
        <th superTableHeader class="rv-left">Year-Month</th>
        <th
          superTableHeader
          class="rv-right"
          [rivTooltip]="
            'remits (835s) with matching claims (837s) / all remits (835s) = 835 Match Rate'
          "
        >
          835 Match Rate
        </th>
        <th
          superTableHeader
          class="rv-right"
          [rivTooltip]="
            'claims (837s) with matching remits (835s) / all claims (837s) = 837 Match Rate'
          "
        >
          837 Match Rate
        </th>
        <th superTableHeader class="rv-right" [style.width.px]="65">
          835 Count
        </th>
        <th superTableHeader class="rv-right" [style.width.px]="65">
          837 Count
        </th>
        <th superTableHeader class="rv-right" [style.width.px]="105">
          Line Item Match Rate
        </th>
        <th superTableHeader class="rv-right" [style.width.px]="65">
          Error Rate
        </th>
      </tr>
      <tr *superTableRow="let entry">
        <td superTableCell>
          <div truncate class="rv-left">{{ entry.year_month }}</div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">
            {{ entry['835_match_rate'] | rivPercentage }}
          </div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">
            {{ entry['837_match_rate'] | rivPercentage }}
          </div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">{{ entry['835_count'] }}</div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">{{ entry['837_count'] }}</div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">
            {{ entry.line_item_match_rate | rivPercentage }}
          </div>
        </td>
        <td superTableCell>
          <div truncate class="rv-right">
            {{ entry.error_rate | rivPercentage }}
          </div>
        </td>
      </tr>
    </super-table>
  </loadable>
</div>
